import { makeAutoObservable } from 'mobx';

export class ErrorStore {
  constructor() {
    makeAutoObservable(this);
  }

  error: null | Error = null;
  setError(err: null | Error) {
    this.error = err;
  }

  clearError() {
    this.error = null;
  }
}

export const errorStore = new ErrorStore();
